/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, April 21st 2023, 5:37:13 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TResourcePolicy, TSubject } from "authorization/abac/types";

interface PagePolicyAttributes {
  permission: string;
}

type TPagePolicy = TResourcePolicy<PagePolicyAttributes>;

class PagePolicy implements TPagePolicy {
  public type: TPagePolicy["type"] = "page";

  checkPolicy(conditions: PagePolicyAttributes, subject: TSubject<PagePolicyAttributes>) {
    return true;
  }
}

export const pagePolicy = new PagePolicy();
